import { WindowTitleProvider } from "./WindowTitleProvider";
import { StringUtil } from "../StringUtil";
import { LogManager } from "../logging/LogManager";

export class WindowTitle {
    private static log = LogManager.getLogger("core.WindowTitle");
    private static titleStack: (() => string)[] = [];
    private static defaultTitle: string = "McLeod Portal";

    public static get(): string {
        const value = this.titleStack.length > 0 ? this.titleStack[this.titleStack.length - 1]() : null;
        return StringUtil.isEmptyString(value) === false ? value : this.defaultTitle;
    }

    public static set(value?: string | (() => string)): void {
        this.push(value, "Deprecated Set Method");
    }

    public static push(value?: string | (() => string), logAction?: string): void {
        if (typeof value === "function") {
            this.titleStack.push(value);
            this.refresh(`${logAction} > Pushed (function)`);
        } else {
            this.titleStack.push(() => value);
            this.refresh(`${logAction} > Pushed (string)`);
        }
    }

    public static pop(logAction?: string): void {
        if (this.titleStack.length > 0)
            this.titleStack.pop();
        this.refresh(`${logAction} > Popped`);
    }

    public static resetWith(value?: string | (() => string), logAction?: string) {
        this.titleStack = [];
        this.push(value, `${logAction} > Reset Stack`);
    }

    public static clear(logAction?: string): void {
        this.titleStack = [];
        this.refresh(`${logAction} > Cleared Stack`);
    }

    public static refresh(logAction?: string): void {
        const provider = WindowTitleProvider.get();
        const title = this.get();
        document.title = provider.finalizeTitle(title);
        this.logTitleStack(`${logAction} > Refreshed`);
    }

    private static logTitleStack(loggingAction: string): void {
        if (!this.log.isDebugEnabled())
            return;

        const titleList = [];
        this.titleStack.map((title) => {
            if (typeof title === "function")
                titleList.push(title());
            else
                titleList.push(title);
        });
        this.log.debug(`WindowTitle refresh actions: [${loggingAction}]`, titleList);
    }
}
